var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuildingLocationAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 464.68 464.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7f8080;}.cls-1,.cls-2,.cls-3,.cls-4{stroke:#000;stroke-miterlimit:10;}.cls-2{fill:#70ae45;}.cls-3{fill:#ed7d2d;}.cls-4{fill:#4473C5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M232.34.5c79.34,0,95.64,91.85,60.4,126.28-29.45,28.77-60.4,89.77-60.4,103.56,0-13.79-30.94-74.79-60.39-103.56C136.7,92.35,153,.5,232.34.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.5,232.34C.5,153,92.35,136.7,126.78,172c28.77,29.45,89.77,60.39,103.56,60.39-13.79,0-74.79,31-103.56,60.4C92.35,328,.5,311.68.5,232.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M232.34,464.18C153,464.18,136.7,372.33,172,337.9c29.45-28.77,60.39-89.77,60.39-103.56,0,13.79,31,74.79,60.4,103.56C328,372.33,311.68,464.18,232.34,464.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M464.18,232.34c0,79.34-91.85,95.64-126.28,60.4-28.77-29.45-89.77-60.4-103.56-60.4,13.79,0,74.79-30.94,103.56-60.39C372.33,136.7,464.18,153,464.18,232.34Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingLocationAll);
export default __webpack_public_path__ + "static/media/building-location-all.36035b14d66072edc907c95c8d4449e1.svg";
export { ForwardRef as ReactComponent };